export enum Board {
  BeadRoad = 'beadRoad',
  BigRoad = 'bigRoad',
  SmallRoad = 'smallRoad',
  CockroachPig = 'cockroachPig',
}

export const DEFAULT_BOARD_ROWS_COUNT: number = 6;
